import React from "react";
import "./style.css";
import logo from "../../assets/images/logoLong.webp";

const Preloader: React.FC = () => {
  return (
    <div className="preloader">
      {/* <h1 className="logo">Oz99</h1> */}
      <img src={logo} alt="ok" style={{ zIndex: 5, width: "10rem" }} />
      <span className="span span0" />
      <span className="span span1" />
      <span className="span span2" />
      <span className="span span3" />
      <span className="span span4" />
    </div>
  );
};

export default Preloader;
